export default {
  coffeeData: {
    windBreaker: "Windbrekerboom",
    horticultureInfo: "Boom in de tuinbouw",
    shadeTree: "Schaduwboom",
    coffeeVariety: "Koffievariëteit",
    coffeeSpecies: "Koffiesoorten",
    coffeeCherryQuality: "Kwaliteit van koffiekers",
    processingBatchQuality: "Kwaliteit van verwerkingsbatch",
    greenCoffeeQuality: "Kwaliteit van groene koffie",
    processType: "Proces Type",
    updateWindBreaker: "Windbrekerboomtype bijwerken",
    addWindBreaker: "Nieuw type windbrekerboom toevoegen",
    updateHorticultureInfo:
      "Informatie over het boomtype in de tuinbouw bijwerken",
    addHorticultureInfo:
      "Nieuwe informatie over boomtype in de tuinbouw toevoegen",
    updateShadeTree: "Schaduwboomtype bijwerken",
    addShadeTree: "Nieuw schaduwboomtype toevoegen",
    updateCoffeeVariety: "Koffievariëteit bijwerken",
    addCoffeeVariety: "Nieuw type boom van koffievariëteit toevoegen",
    deleteVarietyTitle: "Variëteit verwijderen",
    deleteVarietyMessage:
      "Weet je zeker dat je deze variëteit wilt verwijderen?",
    updateCoffeeSpecie: "Koffiesoort bijwerken",
    deleteSpecieTitle: "Soort verwijderen",
    deleteSpecieMessage: "Weet je zeker dat je deze soort wilt verwijderen?",
    addCoffeeSpecie: "Nieuwe koffiesoort toevoegen",
    variety: "Variëteit",
    selectVariety: "Variëteit selecteren",
    selectSpecie: "Soort selecteren",
    deleteCoffeeRecord: "Weet je zeker dat je het record wilt verwijderen?",
    deleteCoffeeData: "Koffiegegevens verwijderen",
    topicRequired: "Naam van het onderwerp is vereist",
    coffeeAddSuccess: "Koffiesoort succesvol toegevoegd.",
    treeTypeSuccess: "Boomtype succesvol toegevoegd.",
    treeTypeUpdateSuccess: "Boomtype succesvol bijgewerkt.",
    coffeeVarietySuccess: "Koffievariëteit succesvol toegevoegd.",
    coffeeSpecieSuccess: "Koffiesoort succesvol bijgewerkt.",
    nameRequired: "Naam is vereist",
    notFound: "Geen koffie-admin-gegevens gevonden",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoOverview: "Cacao Overzicht",
    cacaoVariety: "Cacao Variëteit",
    cacaoSpecies: "Cacao Soort",
    deleteCacaoData: "Cacaogegevens verwijderen",
  },
  memberDataSection: {
    import: "Importeren",
    buyingStation: "Aankoopstation",
    factory: "Fabriek",
    factories: "Fabrieken",
    societies: "Maatschappijen",
    factoriesName: "Fabrieksnaam",
    factoriesProdChart: "Fabrieken produktiegrafiek",
    factoryInfo: "Fabrieksinformatie",
    factoryDashboard: "Fabrieksdashboard",
    factoryDashboardPage: {
      title: "Fabrieksdashboard",
      close: "Sluiten",
      resetFilters: "Filters Resetten",
      apply: "Toepassen",
      monthlySupplyTrend: "Maandelijkse Aanvoertrend",
      processingEfficiency: "Verwerkingsefficiëntie",
      funnelChart: "Trechterdiagram - Invoer -> Uitvoer",
      totalLoss: "Totaal Verlies",
      noTarget: "Geen doel ingesteld",
      ytdScope: "(YTD {year})",
      operationalEfficiency: "Operationele Efficiëntie",
      target: "Doel",
      actual: "Werkelijk",
      farmerParticipation: "Boerenparticipatie - Bijdrageverdeling",
      totalInput: "Totale Invoer",
      totalOutput: "Totale Uitvoer",
      activeFarmers: "Actieve Boeren",
      rawIntake: "Ruwe Inname (Kers Ontvangen)",
      processing: "Verwerking (Kers Verwerkt)",
      output: "Uitvoer (Perkament Geproduceerd)",
      currentPeriod: "Huidige Periode",
      previousPeriod: "Vorige Periode",
      volumePerTopFarmers: "Volume per Topboeren",
      cumulativeImpact: "Cumulatieve Impact (%)",
      deliveries: "Leveringen (kg)",
      operational: "Operationeel",
      volume: "Volume (kg)",
      cumulative: "Cumulatief (%)",
      to: "tot",
      ranges: {
        today: "Vandaag",
        week: "Week",
        month: "Maand",
        year: "Jaar",
        all: "Alles",
      },
    },
    continue: "Doorgaan",
    farmerId: "Boerderij-ID",
    farmerName: "Naam van de boer",
    farmerAddress: "Adres van de boer",
    quality: "Kwaliteit",
    quantity: "Hoeveelheid",
    importAll: "Alles importeren",
    importSelected: "Geselecteerde importeren",
    fileLoaded: "Bestand succesvol geladen",
    incorrectHeaders: "Onjuiste koppen",
    processingBatch: "Batch verwerken",
    purchaseOrder: "Inkooporder",
    buyingStationDetails: "Koopstation Details",
    buyingStationUsers: "Koopstation Gebruikers",
    activityLog: "Activiteitenlogboek",
    startDate: "Startdatum",
    endDate: "Einddatum",
    selectCrop: "Selecteer Gewas",
    purchasingOrder: "Inkooporder",
    totalCoffeeCherry: "Totaal koffiekers",
    airHumidity: "Luchtvochtigheid",
    density: "Dichtheid",
    temperature: "Temperatuur",
    beanMoistureContent: "Vochtgehalte van de boon",
    processType: "Procestype",
    batchRating: "Batchbeoordeling selecteren",
    purchaseDate: "Aankoopdatum",
    selectFarmer: "Boer selecteren",
    selectFarm: "Boerderij selecteren",
    selectPlantation: "Plantage selecteren",
    coffeeVariety: "Koffievariëteit",
    coffeeSpecies: "Koffiesoort",
    coffeeCherryQuantity: "Hoeveelheid koffiekers",
    coffeeCherryQuality: "Kwaliteit van koffiekers",
    coffeeType: "Koffietype",
    pricePerKg: "Prijs per kg",
    processingDone: "Verwerking voltooid",
    processedCoffeeOut: "Verwerkte koffie geleverd",
    farmer: "Boer",
    farm: "Boerderij",
    plantation: "Plantage",
    farmers: "Boeren",
    farmLimitUsed: "Limiet van boerderij gebruikt",
    phoneNumber: "Telefoonnummer",
    farmSize: "Grootte van de boerderij",
    farmLocation: "Boerderij/Locatie",
    date: "Datum",
    status: "Toestand",
    noFarmers: "Geen boeren gevonden",
    approveReject: "Goedkeuren/Afwijzen",
    farms: "Boerderijen",
    crops: "Gewassen",
    equipment: "Apparatuur",
    noFarms: "Geen boerderijen gevonden",
    views: "Weergaven",
    selectStatus: "Status selecteren",
    approved: "Goedgekeurd",
    rejected: "Afgewezen",
    reject: "Afwijzen",
    approve: "Goedkeuren",
    cancel: "Annuleren",
    add: "Toevoegen",
    describeYourReason: "Beschrijf hier uw reden",
    userInformation: "Gebruikersinformatie",
    userFarmRequest: "Boerderijaanvraag van gebruiker",
    userFarmInformation: "Boerderijinformatie van gebruiker",
    activity: "Activiteit",
    activityType: "Type activiteit",
    farmZone: "Boerderijzone",
    farmerView: "Boerenweergave",
    cropType: "Gewastype",
    cropVariety: "Variëteit van het gewas",
    area: "Gebied",
    cost: "Kosten",
    geofence: "Geofence",
    map_views: "Kaartweergaven",
    viewAllFarms: "Alle boerderijen bekijken",
    farmersDetails: "Details van de boer",
    download: "Downloaden",
    pOrder: {
      addNew: "Nieuwe toevoegen",
      viewAll: "Alles bekijken",
      selectDate: "Datum selecteren",
      makeSelection: "Maak een keuze",
      coffeeType: "Koffietype",
      enterPrice: "Prijs invoeren",
      reqPurchaseDate: "Aankoopdatum is verplicht",
      reqFarmer: "Boer is verplicht",
      reqCoffeeQnty: "Hoeveelheid koffiekers is verplicht",
      reqPrice: "Prijs per kg is verplicht",
      grandTotal: "TOTAAL",
      selectDateRange: "Selecteer datumbereik",
      import: "Importeren",
      purchaseId: "Inkoop-ID",
      purchaseDate: "Aankoopdatum",
      farmerName: "Naam van de boer",
      quality: "Kwaliteit",
      quantity: "Hoeveelheid",
      pricePerKg: "Prijs per kg",
      selectBuyingStation: "Aankoopstation selecteren",
      searchUser: "Gebruikers zoeken",
  },
  // Buying Station specific translations
    buyingStations: "Inkoopstations",
    registerBuyingStation: "Inkoopstation Registreren",
    registerFactory: "Fabriek Registreren",
    loadingFactory: "Fabriek wordt geladen...",
    loadingBuyingStation: "Inkoopstation wordt geladen...",
    searchBuyingStation: "Inkoopstation Zoeken",
    searchFactory: "Fabriek Zoeken",
    searchSociety: "Maatschappij Zoeken",
    nameAndId: "Naam / ID",
    email: "E-mail",
    mobileNumber: "Mobiel nummer",
    role: "Rol",
    actions: "Acties",
    view: "Bekijken",
    edit: "Bewerken",
    activate: "Activeren",
    deactivate: "Deactiveren",
    operator: "Operator",
    supplier: "Leverancier",
    active: "Actief",
    deactivated: "Gedeactiveerd",
    activatedSuccessfully: "Inkoopstation succesvol geactiveerd",
    deactivatedSuccessfully: "Inkoopstation succesvol gedeactiveerd",
    deletedSuccessfully: "Aankoopstation succesvol verwijderd",
    duplicatedSuccessfully: "Aankoopstation succesvol gedupliceerd",
  
    factoryActivatedSuccessfully: "Fabriek succesvol geactiveerd",
    factoryDeactivatedSuccessfully: "Fabriek succesvol gedeactiveerd",
    factoryRegisteredSuccessfully: "Fabriek succesvol geregistreerd",
    
    // Buying Station Details specific translations
    userDetails: "Gebruikersdetails",
    name: "Naam",
    provinceState: "Provincie/Staat",
    villageCityTown: "Dorp/Stad/Plaats",
    country: "Land",
    associatedFarms: "Gekoppelde Boerderijen",
    back: "Terug",
    addPurchaseOrder: "Inkooporder Toevoegen",
    cherryCollection: "Kersenoogst",
    addCherryCollection: "Kersenoogst Toevoegen",
    search: "Zoeken",
    orderId: "Order ID",
    farmFarmer: "Boerderij / Boer",
    coffeeSpeciesVariety: "Koffiesoort / Variëteit",
    quantityPrice: "Hoeveelheid / Prijs",
    delete: "Verwijderen",
    
    // Processing Batch specific translations
    addProcessingBatch: "Verwerkingsbatch Toevoegen",
    batchId: "Batch ID",
    lots: "Partijen",
    greenCoffeeOut: "Groene Koffie Uit",
    startEndDate: "Startdatum / Einddatum",
    
    // Associated Farms specific translations
    addFarm: "Boerderij Toevoegen",
    farmNameAndId: "Boerderijnaam & ID",
    addressOfProduction: "Productieadres",
    areaHa: "Oppervlakte (ha)",
    type: "Type",
    eudrDeforestationStatus: "EUDR Ontbossingsstatus",
    eudrDeforestationStatusTT: "EUDR Risicobeoordeling Ontbossing",
    zeroNegligibleProbability: "Zero/Verwaarloosbare Waarschijnlijkheid",
    assessments: "Beoordelingen",
    riskAssessment: "Risicobeoordeling",
    compliant: "Conform",
    nonCompliant: "Niet-conform",
    pending: "In behandeling",
    dateOfSubmission: "Datum van Indiening",
    dateOfExpiry: "Vervaldatum",
    selectFarms: "Boerderijen Selecteren",
    reviewSelection: "Selectie Beoordelen",
    next: "Volgende",
    reviewMappingPrompt: "U heeft {count} boerderij(en) geselecteerd. Bevestig om ze te koppelen aan dit aankoopstation.",
    confirmMapping: "Koppeling Bevestigen",
    farmsMappedSuccess: "Boerderijen succesvol gekoppeld",
    farmsMappedError: "Koppelen van boerderijen mislukt",
    owner: "Eigenaar",

    buyingStationOrder: {
      bulkImport: {
        importBulkData: "Gegevens in Bulk Importeren",
        importButton: "Inkooporders in Bulk Importeren",
        title: "Bulk Import Inkooporder Gegevens",
        // Upload tab
        templateNote: "Download en gebruik de onderstaande sjablonen om inkooporders in bulk te importeren.",
        selectTemplate: "Sjabloon Selecteren",
        templateXls: "XLS-formaat Importeren",
        downloadXls: "XLS-formaat Downloaden",
        selectFile: "Selecteer bestand om de Gegevens te Uploaden",
        dropHere: "of sleep en zet hier neer",
        fileUploaded: "Het bestand is succesvol geüpload.",
        importantNote: "Belangrijke Opmerking",
        importantNoteDetail:
          "Gebruik de hierboven verstrekte sjablonen voor bulkuploads. Andere formaten leiden tot een fout.",
        unsupportedFileFormat: "Dit bestandsformaat wordt niet ondersteund.",
        invalidFileFormat: "Upload een geldig .xlsx-, .xls- of .csv-bestand met behulp van het verstrekte sjabloon.",
        templateErrorIntro:
          "Het geüploade bestand komt niet overeen met het vereiste sjabloon. Download het sjabloon en probeer het opnieuw.",
        importingTitle: "Importeren...",
        importingNote:
          "Uw geüploade bestanden worden momenteel verwerkt.\nWe stellen u op de hoogte zodra de bestanden succesvol zijn geüpload.",
        // Result page
        importCompleted: "Import Voltooid",
        recordsReadyToImport: "records klaar om te importeren",
        tabTotalRecords: "Totaal Records",
        tabSuccess: "Succes",
        tabIssues: "Problemen",
        filterAll: "Alles",
        filterSuccess: "Succes",
        issuesDetected: "Problemen Gedetecteerd",
        issuesDetectedHeading: "Discrepantie gedetecteerd:",
        issuesDetectedDescription:
          "Sommige rijen hebben gegevensproblemen (bijv. ongeldige aankoopdatum, onbekende boer, boerderij of koffiegegevens). Controleer en los deze op vóór de definitieve indiening.",
        deleteRowsWithIssues: "Rijen met Gegevensdiscrepanties Verwijderen",
        // Table headers
        purchaseDate: "Aankoopdatum",
        farmer: "Boer",
        farm: "Boerderij",
        buyingStation: "Aankoopstation",
        coffeeQuantityQuality: "Koffiehoeveelheid & Kwaliteit",
        plantation: "Plantage",
        coffeeSpecies: "Koffiesoort",
        coffeeVariety: "Koffievariëteit",
        coffeeType: "Koffietype",
        coffeeCherryQuantity: "Hoeveelheid koffiekers",
        coffeeCherryQuality: "Kwaliteit van koffiekers",
        pricePerKg: "Prijs per kg",
        receiptNo: "Ontvangstbewijs Nr.",
        lotId: "Lot-ID",
        photos: "Foto's",
        // Actions / dialogs
        purchaseOrder: "Inkooporder",
        detailsTitle: "Inkooporderdetails",
        editRecord: "Record bewerken",
        deleteRecord: "Record verwijderen",
        deleteRecordConfirm:
          "Weet u zeker dat u dit record wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        deleteDiscrepancyConfirm:
          "Weet u zeker dat u alle {count} rij(en) met problemen wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        cancelImportTitle: "Import Annuleren",
        cancelImportConfirm:
          "Weet u zeker dat u deze import wilt annuleren? Gevalideerde records kunnen niet meer worden geïmporteerd.",
        cancelImportConfirmBtn: "Import Annuleren",
        importConfirm: "Nu {count} geldige record(s) importeren?",
        recordUpdatedSuccess: "Record succesvol bijgewerkt.",
        recordsDeletedSuccess: "Records succesvol verwijderd.",
        importCancelledSuccess: "Import succesvol geannuleerd.",
        genericError: "Er is iets misgegaan. Probeer het opnieuw.",
        noDataFound: "Geen gegevens gevonden.",
        // Edit dialog
        selectFactory: "Fabriek selecteren",
        selectFarmer: "Boer selecteren",
        selectFarm: "Boerderij selecteren",
        selectPlantation: "Plantage selecteren",
        submit: "Verzenden",
        addImage: "Afbeelding toevoegen",
        addedBy: "Toegevoegd door",
        close: "Sluiten",
        // Success dialog
        successDialogTitle: "Succesbericht",
        importedSuccessfully: "{count} inkooporder(s) zijn succesvol geïmporteerd.",
        // History
        historyFile: "Bestandsnaam",
        historyImportedOn: "Geïmporteerd Op",
        historyEmpty: "Nog geen bulkimportgeschiedenis.",
        statusValidating: "Valideren",
        statusSuccess: "Geïmporteerd",
        statusCancelled: "Geannuleerd",
        // Error-code labels (tooltips / field messages)
        errorInvalidPurchaseDate: "De aankoopdatum is ongeldig.",
        errorMissingPurchaseDate: "De aankoopdatum ontbreekt.",
        errorMissingMemberId: "Het lid-ID ontbreekt.",
        errorInvalidMemberIdFormat: "Het formaat van het lid-ID is ongeldig. Verwacht: Naam boer - Naam aankoopstation - ID boerderij.",
        errorInvalidFarmerName: "De boer is niet gevonden in uw organisatie.",
        errorInvalidBuyingStationName: "Het aankoopstation is niet gevonden in uw organisatie.",
        errorInvalidFarm: "De boerderij is niet gevonden in uw organisatie.",
        errorMissingQuantity: "De hoeveelheid koffiekers ontbreekt.",
        errorInvalidQuantity: "De hoeveelheid koffiekers moet een getal groter dan nul zijn.",
        errorMissingQuality: "De kwaliteit van de koffiekers ontbreekt.",
        errorInvalidQuality: "De kwaliteit van de koffiekers werd niet herkend.",
        errorMissingPrice: "De prijs ontbreekt.",
        errorInvalidPrice: "De prijs moet een geldig getal zijn.",
        // Filter chip short labels
        chipInvalidPurchaseDate: "Ongeldige Aankoopdatum",
        chipMissingPurchaseDate: "Ontbrekende Aankoopdatum",
        chipMissingMemberId: "Ontbrekend Lid-ID",
        chipInvalidMemberIdFormat: "Ongeldig Lid-ID Formaat",
        chipInvalidFarmerName: "Ongeldige Boer",
        chipInvalidBuyingStationName: "Ongeldig Aankoopstation",
        chipInvalidFarm: "Ongeldige Boerderij",
        chipMissingQuantity: "Ontbrekende Hoeveelheid",
        chipInvalidQuantity: "Ongeldige Hoeveelheid",
        chipMissingQuality: "Ontbrekende Kwaliteit",
        chipInvalidQuality: "Ongeldige Kwaliteit",
        chipMissingPrice: "Ontbrekende Prijs",
        chipInvalidPrice: "Ongeldige Prijs",

      },
    },
    processingBatchBulkImport: {
      bulkImport: "Verwerkingsbatches Bulk Importeren",
      title: "Bulk Import Verwerkingsbatches",
      instructions: "Upload een CSV- of XLSX-bestand via de onderstaande sjabloon. Elke rij maakt één verwerkingsbatch.",
      downloadCsv: "CSV-sjabloon downloaden",
      downloadXlsx: "XLSX-sjabloon downloaden",
      selectFile: "Selecteer CSV- of XLSX-bestand",
      rowsParsed: "{count} rij(en) klaar om te importeren.",
      import: "Importeren",
      imported: "{created} van {total} batch(es) geïmporteerd.",
      failed: "{failed} rij(en) mislukt.",
      rowError: "Rij {row}",
      emptyFile: "Het bestand heeft geen gegevensrijen.",
      missingColumns: "Vereiste kolom(men) ontbreken: {columns}",
      noBuyingStation: "Geen inkoopstation geselecteerd.",
      validating: "Rijen valideren…",
      total: "Totaal",
      valid: "Geldig",
      invalid: "Ongeldig",
      all: "Alle",
      statusValid: "Geldig",
      statusInvalid: "Ongeldig",
      issues: "Problemen",
      back: "Terug",
      importValid: "Importeer {count} geldige rij(en)",
      done: "Klaar",
      rowCol: "Rij",
      startDateCol: "Verwerkingsdatum",
      purchaseOrdersCol: "Aankoopcodes",
      processTypeCol: "Verwerkingstype",
      gradeCol: "Kwaliteitsklasse",
      seasonCol: "Seizoen",
      statusCol: "Status",
      purchaseDateCol: "Aankoopdatum",
      processDateCol: "Verwerkingsdatum",
      parchmentCol: "Perkament (Kg)",
      bagsCol: "Zakken",
      vehiclePlateCol: "Kenteken",
      harvestedCol: "Geoogst",
      pulpedCol: "Gepulpeerd",
      washedCol: "Gewassen",
      dryingStartedCol: "Drogen Gestart",
      movedToStoreCol: "Verplaatst naar Opslag",
      templateNote: "Download en gebruik de onderstaande sjablonen voor bulk import van verwerkingsbatches.",
      selectTemplate: "Sjabloon Selecteren",
      templateCsv: "CSV Importformaat",
      templateXls: "XLS Importformaat",
      downloadCsvFormat: "CSV-formaat Downloaden",
      downloadXls: "XLS-formaat Downloaden",
      importingTitle: "Bulk Import Verwerkingsbatches",
      importingNote: "Uw geüploade bestand wordt verwerkt.\nKlik niet op annuleren, sluiten of vernieuwen om onderbreking te vermijden.",
      importantNote: "Belangrijke Opmerking",
      importantNoteDetail: "Gebruik de bovenstaande sjablonen voor bulk import van verwerkingsbatches. Andere formaten veroorzaken fouten.",
      invalidFileFormat: "Upload een geldig .csv-, .xlsx- of .xls-bestand via de meegeleverde sjabloon.",
      unsupportedFileFormat: "Dit bestandsformaat wordt niet ondersteund.",
      templateErrorIntro: "Het geüploade bestand komt niet overeen met de vereiste sjabloon. Download de sjabloon en probeer opnieuw.",
      importCompleted: "Import Voltooid",
      tabTotalRecords: "Totaal Records",
      tabSuccess: "Geslaagd",
      tabIssues: "Problemen",
      filterAll: "Alle",
      filterSuccess: "Geslaagd",
      issuesDetected: "Problemen Gedetecteerd",
      issuesDetectedHeading: "Problemen Gedetecteerd:",
      issuesDetectedDescription: "Sommige rijen hebben gegevensproblemen (bijv. ontbrekende datums, onbekend verwerkingstype, ongeldig perkamentgewicht). Controleer en los deze op voor de definitieve indiening.",
      deleteRowsWithIssues: "Rijen met problemen verwijderen",
      editRecord: "Record bewerken",
      deleteRecord: "Record verwijderen",
      deleteRecordConfirm: "Weet u zeker dat u dit record wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      deleteDiscrepancyConfirm: "Weet u zeker dat u alle {count} rijen met problemen wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      cancelImportTitle: "Import Annuleren",
      cancelImportConfirm: "Weet u zeker dat u deze import wilt annuleren? Gevalideerde records kunnen niet meer worden geïmporteerd.",
      cancelImportConfirmBtn: "Import Annuleren",
      importConfirm: "Nu {count} geldig(e) record(s) importeren?",
      recordUpdatedSuccess: "Record succesvol bijgewerkt.",
      recordsDeletedSuccess: "Records succesvol verwijderd.",
      importCancelledSuccess: "Import succesvol geannuleerd.",
      genericError: "Er is een fout opgetreden. Probeer het opnieuw.",
      noDataFound: "Geen gegevens gevonden.",
      editRecordTitle: "Record Bewerken",
      submit: "Verzenden",
      detailsTitle: "Details Verwerkingsbatch",
      close: "Sluiten",
      successDialogTitle: "Succesmelding",
      importedSuccessfully: "{count} verwerkingsbatch-record(s) succesvol geïmporteerd.",
      historyFile: "Bestandsnaam",
      historyImportedOn: "Geïmporteerd Op",
      historyEmpty: "Nog geen bulk import geschiedenis.",
      statusValidating: "Valideren",
      statusSuccess: "Geïmporteerd",
      statusCancelled: "Geannuleerd",
      errorCodePurchaseDateRequired: "Aankoopdatum is verplicht.",
      errorCodeInvalidPurchaseDate: "Het formaat van de aankoopdatum wordt niet herkend.",
      errorCodeProcessDateRequired: "Verwerkingsdatum is verplicht.",
      errorCodeInvalidProcessDate: "Het formaat van de verwerkingsdatum wordt niet herkend.",
      errorCodeUnknownProcessType: "Het verwerkingstype wordt niet herkend.",
      errorCodeNoOrdersForDate: "Geen inkooporders gevonden voor de opgegeven aankoopdatum.",
      errorCodeParchmentInvalid: "De perkamentwaarde (Kg) is ongeldig.",
      errorCodeParchmentExceedsCherry: "Perkament (Kg) mag de totale hoeveelheid koffiebessen niet overschrijden.",
      errorCodeInvalidData: "Een of meer velden bevatten ongeldige gegevens.",
      chipPurchaseDateRequired: "Aankoopdatum Vereist",
      chipInvalidPurchaseDate: "Ongeldige Aankoopdatum",
      chipProcessDateRequired: "Verwerkingsdatum Vereist",
      chipInvalidProcessDate: "Ongeldige Verwerkingsdatum",
      chipUnknownProcessType: "Onbekend Verwerkingstype",
      chipNoOrdersForDate: "Geen Orders voor deze Datum",
      chipParchmentInvalid: "Ongeldig Perkament",
      chipParchmentExceedsCherry: "Perkament Overschrijdt Bessen",
      chipInvalidData: "Ongeldige Gegevens",
    },
    greenCoffee: {
      bulkImport: {
        importButton: "Groene Koffie in Bulk Importeren",
        title: "Bulk Import Groene Koffie Gegevens",
        breadcrumb: "Koffieoverzicht > Droog Malen",
        tabImport: "Importeren",
        tabHistory: "Geschiedenis",
        templateNote:
          "Download en gebruik de onderstaande sjablonen om groene koffie in bulk te importeren.",
        selectTemplate: "Sjabloon Selecteren",
        templateXls: "XLS-formaat Importeren",
        importingTitle: "Bulk Import Groene Koffie Gegevens",
        importingNote:
          "Uw geüploade bestand wordt momenteel verwerkt.\nKlik niet op annuleren, sluit of vernieuw deze pagina niet om onderbreking te voorkomen.",
        importCompleted: "Import Voltooid",
        tabTotalRecords: "Totaal Records",
        tabSuccess: "Succes",
        tabFailed: "Mislukt",
        tabIssues: "Problemen",
        tabDataDiscrepancies: "Gegevensdiscrepanties",
        filterAll: "Alles",
        filterSuccess: "Succes",
        filterIssues: "Problemen",
        issuesDetectedHeading: "Problemen Gedetecteerd:",
        issuesDetectedDescription:
          "Sommige partijen hebben gegevensproblemen (bijv. ongeldig productienummer, productienummer bestaat niet in het systeem). Controleer en los deze op vóór de definitieve indiening.",
        deleteLotsWithDataDiscrepancies: "Partijen met Gegevensdiscrepanties Verwijderen",
        lotId: "Lot-ID",
        lotIdAndOutturn: "Lot-ID & Productie",
        grower: "Teler",
        coffeeType: "Koffietype",
        grossAndNetWeight: "Brutogewicht & Nettogewicht",
        issuesDetected: "Problemen Gedetecteerd",
        issueOutturnNumberMismatchTitle: "Productienummer komt niet overeen:",
        issueOutturnNumberMismatchDescription:
          "Deze productie komt niet overeen met bestaande Pergaminoleveringsrecords. Zorg ervoor dat het Productienummer handmatig is gekoppeld op Fabrieksniveau voordat u opnieuw uploadt.",
        issueDuplicateOutturnNumberTitle: "Dubbel Productienummer:",
        issueDuplicateOutturnNumberDescription:
          "Het productienummer komt meerdere keren voor in dit geüploade document.",
        issueMissingOutturnNumberTitle: "Ontbrekend Productienummer:",
        issueMissingOutturnNumberDescription:
          "De geüploade rij bevat geen Productienummer. Een geldige, unieke Productie-identificatie is vereist om het record te matchen met het fabriekssysteem.",
        issueGrowerIdentityMismatchTitle: "Identiteit Teler Komt Niet Overeen:",
        issueGrowerIdentityMismatchDescription:
          "Het productienummer is in ons systeem geregistreerd onder Teler {mobileGrowerName}, maar het geüploade bestand wijst het toe aan {xlsGrowerName}. Overschrijven van gegevens beperkt.",
        issueMissingGrowerCredentialsTitle: "Ontbrekende Teler-gegevens:",
        issueMissingGrowerCredentialsDescription:
          "In het record ontbreekt de Naam van de Teler of het Teler-ID. Deze gegevensvelden zijn verplicht om het eigendom van de fabriek te verifiëren voordat de batch kan worden afgestemd.",
        editRecord: "Record bewerken",
        deleteRecord: "Record verwijderen",
        downloadXls: "XLS-formaat Downloaden",
        selectFile: "Selecteer bestand om de Gegevens te Uploaden",
        dropHere: "of sleep en zet hier neer",
        importantNote: "Belangrijke Opmerking",
        importantNoteDetail:
          "Gebruik de hierboven verstrekte sjablonen om groene koffie in bulk te importeren. Andere formaten leiden tot een fout.",
        invalidFileFormat: "Upload een geldig .xlsx- of .xls-bestand met behulp van het verstrekte sjabloon.",
        unsupportedFileFormat: "Dit bestandsformaat wordt niet ondersteund.",
        importFailed: "Import Mislukt",
        importFailedIntro:
          "Het bestand kon niet worden geïmporteerd. Controleer het sjabloonformaat en de rijgegevens en probeer het opnieuw.",
        templateErrorIntro:
          "Het geüploade bestand komt niet overeen met het vereiste sjabloon. Download het XLS-sjabloon en probeer het opnieuw.",
        tryAgain: "Opnieuw Proberen",
        errorDetails: "Details",
        historyEmpty: "Nog geen bulkimportgeschiedenis.",
        // Validation review / import flow
        validationSummaryTitle: "Validatiesamenvatting",
        recordsReadyToImport: "records klaar om te importeren",
        editRecordTitle: "Record Bewerken",
        growerCode: "Teler-code",
        growerName: "Naam Teler",
        greenBeansTotal: "Invoergewicht Met Zakken (Kg)",
        selectedCount: "geselecteerd",
        deleteSelected: "Geselecteerde Verwijderen",
        deleteRecordConfirm:
          "Weet u zeker dat u dit record wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        deleteSelectedConfirm:
          "Weet u zeker dat u de {count} geselecteerde record(s) wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        deleteDiscrepancyConfirm:
          "Weet u zeker dat u alle {count} partij(en) met gegevensdiscrepanties wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        cancelImportTitle: "Import Annuleren",
        cancelImportConfirm:
          "Weet u zeker dat u deze import wilt annuleren? Gevalideerde records kunnen niet meer worden geïmporteerd.",
        cancelImportConfirmBtn: "Import Annuleren",
        importConfirm: "Nu {count} geldige record(s) importeren?",
        recordUpdatedSuccess: "Record succesvol bijgewerkt.",
        recordsDeletedSuccess: "Records succesvol verwijderd.",
        importCancelledSuccess: "Import succesvol geannuleerd.",
        importSuccess: "Import succesvol voltooid.",
        genericError: "Er is iets misgegaan. Probeer het opnieuw.",
        // Issue / error-code labels
        issueInvalidDataTitle: "Ongeldige Gegevens:",
        issueInvalidDataDescription:
          "Een of meer velden bevatten ongeldige gegevens. Controleer en corrigeer ze.",
        errorCodeOutturnMismatch:
          "Dit productienummer komt niet overeen met een bestaand pergaminoleveringsrecord.",
        errorCodeOutturnMissing: "Productienummer ontbreekt.",
        errorCodeOutturnDuplicate:
          "Dit productienummer is dubbel in het bestand of bestaat al in het systeem.",
        errorCodeGrowerMismatch:
          "Naam/code van teler komt niet overeen met de geregistreerde pergaminolevering.",
        errorCodeGrowerMissing: "Naam of code van teler ontbreekt.",
        errorCodeInvalidData: "Een of meer velden bevatten ongeldige gegevens.",
        // History table
        historyFile: "Bestandsnaam",
        historyImportedOn: "Geïmporteerd Op",
        historyUploadedBy: "Geüpload Door",
        historyCreatedDate: "Aanmaakdatum",
        historyTotalRecords: "Totaal Records",
        historyErrorRecords: "Foutrecords",
        // Bulk import status labels
        statusValidating: "Valideren",
        statusSuccess: "Geïmporteerd",
        statusCancelled: "Geannuleerd",
        // Edit record dialog
        editFieldId: "ID",
        inputWeightWithBags: "Invoergewicht Met Zakken",
        qualityControl: "Kwaliteitscontrole",
        submit: "Verzenden",
        noMillingOutputs: "Geen maaluitvoerdetails.",
        millingCleanCoffee: "Schone Koffie (Maaluitvoerdetails)",
        millingBags: "Zakken (Maaluitvoerdetails)",
        millingPockets: "Vakken (Maaluitvoerdetails)",
        millingWeight: "Gewicht (Maaluitvoerdetails)",
        millingBulkOutturn: "Bulkproductie (Maaluitvoerdetails)",
        millingRatio: "Verhouding (Maaluitvoerdetails)",
        // Detail dialog
        detailsTitle: "Groene Koffie Details",
        outturnNo: "Productienr.",
        close: "Sluiten",
        // Success dialog
        successDialogTitle: "Succesbericht",
        importedSuccessfully:
          "{count} groene koffie record(s) zijn succesvol geïmporteerd.",
        // Filter chip short labels (per error category)
        chipOutturnMismatch: "Productienummer Komt Niet Overeen",
        chipOutturnMissing: "Ontbrekend Productienummer",
        chipOutturnDuplicate: "Dubbel Productienummer",
        chipGrowerMismatch: "Identiteit Teler Komt Niet Overeen",
        chipGrowerMissing: "Ontbrekende Teler-gegevens",
        chipInvalidData: "Ongeldige Gegevens",
      },
      processGreenCoffee: "Groene Koffie Verwerken",
      addedBy: "Toegevoegd door",
      selectProductType: "Selecteer Producttype",
      processDate: "Verwerkingsdatum",
      selectProcessingBatch: "Selecteer Verwerkingsbatch",
      lotIdAndDate: "Batch-ID & Datum",
      typeAndQuantity: "Type & Hoeveelheid",
      supplier: "Leverancier",
      outturnNumber: "Productienummer",
      totalInputQuantity: "Totale Invoerhoeveelheid (kg)",
      qualityControl: "Kwaliteitscontrole",
      airHumidity: "Luchtvochtigheid (waarde in %)",
      density: "Dichtheid (kg/cm3)",
      greenCoffeeQualityScore: "Kwaliteitsscore Groene Koffie",
      batchProduction: "Batchproductie",
      unsortedGreenBeans: "Ongesorteerde Groene Bonen (kg)",
      batchProductionDensity: "Batchproductiedichtheid (kg/cm3)",
      percentagePrimaryDefect: "Percentage primair defect",
      percentageSecondaryDefect: "Percentage secundair defect",
      greenBeans: "Groene Bonen",
      totalGreenBeans: "Totaal groene bonen (kg)",
      unitSize: "Eenheidsgrootte (kg)",
      totalBags: "Totaal zakken",
      leftoverQuantity: "Resterende hoeveelheid",
      leftoverQuantityDesc: "De Resterende Hoeveelheid is het overgebleven bedrag dat geen volledige zak kan vormen. Het vertegenwoordigt de hoeveelheid die overblijft na het vullen van het maximale aantal volledige eenheden uit de totale voorraad.",
      expiryDate: "Vervaldatum",
      label: "Label",
      qualityControlButton: "Kwaliteitscontrole",
      valueInPercent: "waarde in %",
      kgCm3: "kg/cm3",
      complete: "Voltooid",
      lotIdOutturnNo: "Batch-ID / Productienummer",
      startDate: "Startdatum",
      greenBeansQualityGrading: "Kwaliteitsbeoordeling Groene Bonen",
      totalQuantity: "Totale hoeveelheid",
      quantity: "Hoeveelheid",
      packing: "Verpakking",
      bag: "Zak",
      qualityScore: "Kwaliteitsscore",
      noLotsYet: "Nog geen partijen. Voeg kwaliteitsbeoordelingen toe vanuit de aanmaakstroom.",
      lotId: "Batch-ID",
      percentage: "Percentage",
      createQualityGrade: "Kwaliteitsbeoordeling Aanmaken",
      finishGrading: "Beoordeling Voltooien",
      finishGradingDesc: "Zodra voltooid, kunt u deze partij niet meer beoordelen. Afval wordt automatisch berekend na voltooiing.",
      finishGradingButton: "Beoordeling Voltooien",
      addNewQualityGrade: "Nieuwe Kwaliteitsbeoordeling Toevoegen",
      totalGreenBeansExceeded: "De totale beoordeelde hoeveelheid mag het totaal groene bonen niet overschrijden.",
      lotIdAlreadyExists: "Dit lot-ID is al in gebruik. Gebruik een ander lot-ID.",
      toAddRecord: "om een record toe te voegen.",
      registeredSuccess: "Groene koffie succesvol geregistreerd",
      exportNotImplemented: "Exporteren niet geïmplementeerd",
      processingBatchRequired: "Verwerkingsbatch is verplicht",
      outturnAvailable: "Productienummer is beschikbaar",
      outturnExists: "Dit productienummer bestaat al. Voer een uniek nummer in.",
      totalGreenBeansRequired: "Totaal groene bonen is verplicht",
      enterHere: "Voer hier in",
      viewTitle: "Kwaliteitsbeoordeling groene bonen",
      parchmentInformation: "Pergamininformatie",
      processInformation: "Procesinformatie",
      greenBeansInformation: "Informatie groene bonen",
      traceabilityLabel: "Traceerbaarheidslabel",
      waste: "Afval",
      downloadLabel: "Label downloaden",
      startCupping: "Start cupping",
      cuppingHistory: "Cuppinggeschiedenis",
      noDataFound: "Geen gegevens gevonden.",
      noParchmentBatches: "Geen pergaminobatches gekoppeld.",
      noQualityGrades: "Geen kwaliteitsbeoordelingen geregistreerd.",
      batchId: "Batch-ID",
      species: "Soort",
      variety: "Variëteit",
      process: "Proces",
      batchRating: "Batchbeoordeling",
      humidity: "Vochtigheid",
      totalCoffeeCherryQty: "Totaal koffiekershoeveelheid",
      weightBeforeProcessing: "Gewicht vóór verwerking",
      numberOfBags: "Aantal zakken",
      externalId: "Externe ID",
      qrCode: "QR-code",
      latestCuppingScore: "Laatste cuppingscore",
      totalWaste: "Totaal afval",
      close: "Sluiten",
      unitSizeKgBag: "Eenheidsgrootte (kg/zak)",
      grade: "Graad",
      selectGrade: "Selecteer graad",
      quantityRequired: "Hoeveelheid is verplicht",
      quantityMustBePositive: "Hoeveelheid moet groter zijn dan 0",
      unitSizeRequired: "Eenheidsgrootte is verplicht",
      unitSizeMustBePositive: "Eenheidsgrootte moet groter zijn dan 0",
      gradeRequired: "Graad is verplicht",
      labelRequired: "Label is verplicht",
      cupping: "Cupping",
      cuppingInformation: "Cuppinginformatie",
      cupperName: "Naam proever",
      cuppingDate: "Cuppingdatum",
      enterCupperName: "Voer naam proever in",
      attachFiles: "Bestand(en) bijvoegen",
      selectFilesToUpload: "Selecteer bestand(en) om gegevens te uploaden",
      orDragAndDrop: "of sleep en zet hier neer",
      lightRoast: "Lichte Branding",
      roastingTime: "Brandtijd",
      roastingTemperature: "Brandtemperatuur",
      qualities: "Kwaliteiten",
      uniformity: "Uniformiteit",
      cleanCup: "Schone Kop",
      sweetness: "Zoetheid",
      overall: "Algemeen",
      defects: "Defecten",
      finalScore: "Eindscore",
      sessionDetails: "Sessiedetails",
      noCuppingHistory: "Geen cuppinggeschiedenis voor deze groene koffie.",
      cuppingDataSaved: "Cuppinggegevens opgeslagen.",
      date: "Datum",
      roast: "Branding",
      score: "Score",
    },
    confirmDialog: {
      delete: {
        title: "Inkoopstation Verwijderen",
        message: "Weet u zeker dat u dit inkoopstation wilt verwijderen?",
        confirmBtn: "Verwijderen",
      },
      activate: {
        title: "Activeren",
        message: "Weet u zeker dat u dit {entity} wilt activeren?",
        confirmBtn: "Activeren",
      },
      deactivate: {
        title: "Deactiveren",
        message: "Weet u zeker dat u dit {entity} wilt deactiveren?",
        confirmBtn: "Deactiveren",
      },
    },
    
    registerNewFactory: "Nieuwe Fabriek Registreren",
    selectHowYouWantToProceed: "Selecteer hoe u wilt doorgaan",
    single: "Enkelvoudig",
    multiple: "Meervoudig",
    user: "Gebruiker",
    createNewFactory: "Nieuwe Fabriek Aanmaken",
    factoryName: "Fabrieksnaam",
    factoryNumber: "Fabrieksnummer",
    firstName: "Voornaam",
    lastName: "Achternaam",
    primaryEmailAddress: "Primair E-mailadres",
    submit: "Verzenden",
    downloadTemplate: "Download Modell",
    templateInfo: "Download het modelbestand om het vereiste formaat te zien voor de massa-registratie.",
    templateFormat: "Voer het bestand in CSV-formaat in.",
    selectFileToUpload: "Selecteer het bestand om de gegevens te uploaden",
    uploadFileOrDragAndDrop: "of sleep en laad hierheen",
} 
};
